import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { v4 as uuid } from "uuid";
import { GOOGLE_PLACES_SESSION_KEY } from "../constants";

const getPlace = async ({ placeId, sessionToken }) => {
    const params = new URLSearchParams({
        "place-id": placeId,
        "session-token": sessionToken,
    });

    return axios
        .get(`/wp-json/api/adpt/place?${params.toString()}`)
        .then((res) => res?.data);
};

export default function usePlace() {
    let sessionToken = window.sessionStorage.getItem(GOOGLE_PLACES_SESSION_KEY);

    if (!sessionToken) {
        const token = uuid();

        window.sessionStorage.setItem(GOOGLE_PLACES_SESSION_KEY, token);
        sessionToken = token;
    }

    return useMutation(({ placeId }) => getPlace({ placeId, sessionToken }));
}
